export { default } from "./GlobalStyles.js";
export * from "./GlobalStyles.js";